import request from '../request/request';
import packageJson from './../../package';

export function parseVersion (versionText) {
  return versionText.substring(versionText.indexOf('('), -1);
}

export function getCurrentVersion () {
  return packageJson.version;
}

export function checkVersion(){
    return new Promise(function (resolve, reject) {
        request({
            type: 'get',
            url: `/static/version.txt?time=${Date.now()}`,
            success(rep) {
                resolve(rep)
            },
            error(err) {
                reject(err)
            }
        })
    })
}



// WEBPACK FOOTER //
// ./src/data/versionService.js